// extracted by mini-css-extract-plugin
export var actions = "_sk-4";
export var item = "_sk-1";
export var price = "_sk-3";
export var quantity = "_sk-2";
export var table = "_sk-0";